import {useEffect} from "react";
import {sendYandexMetrikaRgsEvent} from "../analytics";

export const useMetrikaRgsInsured = (order, userData) => {
    const isInsuranceEnabled  = order?.is_insured;
    const isWasInsured = userData?.is_insurance
    useEffect(() => {
        if (typeof isInsuranceEnabled === 'undefined' || !isWasInsured) return;

        let insuranceStatusEvent = isInsuranceEnabled
            ? 'rgs-checkbox-status_enabled'
            : 'rgs-checkbox-status_disabled';

        sendYandexMetrikaRgsEvent('rgs-checkbox-status_add_rgs', insuranceStatusEvent);

        if(isInsuranceEnabled) sendYandexMetrikaRgsEvent('rgs-checkbox-status_add_rgs_enable')
    }, [isInsuranceEnabled]);
}